import { useQueryClient } from "@tanstack/react-query";
import React, { useContext, useState } from "react";

import {
  useQueryGetUserClassrooms,
  useQueryListClassroomPlannerItems,
  useAppContext,
} from "@examspark/common-app";
import { Button, ButtonProps } from "@examspark/common-ui";
import { IconCalendarLine } from "@examspark/common-ui/dist/components/icons";
import { AnyResource, ParsedClassroom } from "@examspark/types";

import { ClassroomContext } from "../../contexts/ClassroomProvider";

import PinResourceToDateModal from "./units/PinResourceToDateModal";

type Props = {
  resource: AnyResource;
  classroom?: ParsedClassroom;
  unitId?: string;
} & Pick<ButtonProps, "variant">;

const PinToPlannerButton = ({
  resource,
  classroom,
  unitId,
  ...buttonProps
}: Props) => {
  const [state] = useAppContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const client = useQueryClient();
  const _classroom = useContext(ClassroomContext);
  classroom = classroom ?? _classroom;
  const { data: plannerItems } = useQueryListClassroomPlannerItems(
    classroom?.id,
  );
  const { data: classrooms } = useQueryGetUserClassrooms(
    state.workspaceUser?.id,
    state.user?.id,
  );

  const filteredPlannerItems = plannerItems?.filter((item) => {
    const [, , resourceId] = item.sk.split(":");
    return resourceId === `${resource?.id}/${resource?.sk}`;
  });

  const invalidateQuery = () => {
    client.invalidateQueries(["classroom", classroom?.id, "planner-items"]);
  };

  const disabled = classrooms?.length ? undefined : true;

  return (
    <>
      <PinResourceToDateModal
        resource={resource}
        classroom={classroom}
        // unitId=""
        isOpen={isModalOpen}
        onRequestClose={() => {
          setIsModalOpen(false);
          invalidateQuery();
        }}
        onComplete={() => {
          setIsModalOpen(false);
          invalidateQuery();
        }}
      />
      <Button
        title="Pin to Planner"
        variant={filteredPlannerItems?.length ? "contained" : "outlined"}
        disabled={disabled}
        color={filteredPlannerItems?.length ? "create" : "secondary"}
        onClick={(e) => {
          setIsModalOpen(true);
        }}
        {...buttonProps}
      >
        <IconCalendarLine width="16" />
        {!!filteredPlannerItems?.length && <>{filteredPlannerItems.length}</>}
      </Button>
    </>
  );
};

export default PinToPlannerButton;
